import React, { useContext } from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import { CSSTransition } from "react-transition-group";
import cl from "classnames";
import TextInput from "../fields/TextInput";
import Checkbox from "../fields/Checkbox";
import CorporateOrPrivateRadio from "../fields/CorporateOrPrivateRadio";
import classes from "../../styles/styles.module.scss";
import stage3Classes from "../../styles/corpOrPrivate.module.scss";
import companyNameFieldTransitions from "../../styles/companyNameFieldTransitions.module.scss";
import { ConfigContext } from "../../context";
import { venueFinderFlavours } from "../../constants";
import AnimatedWarningAlert from "venuescanner-js/react/components/Alert/AnimatedWarningAlert";
import BudgetRange from "../fields/BudgetRange";

const eventDescriptionPlaceholder =
  "Use this space to give as much detail as possible about your event: prosecco… performance… popcorn… presentation… photographer…";

const BUDGET_NAME = "budget";
const PriceSlider = connect(
  ({
    formik: {
      setFieldValue,
      values: { [BUDGET_NAME]: value },
      errors: { [BUDGET_NAME]: error },
      touched: { [BUDGET_NAME]: touched },
    },
  }) => (
    <div className={classes.FieldWrapper}>
      <p>What's your event budget?</p>
      <BudgetRange
        onChange={(val) => {
          setFieldValue(BUDGET_NAME, val);
          window.dataLayer.push({ event: BUDGET_NAME });
        }}
        value={value || []}
      />
      <AnimatedWarningAlert
        text={touched && error}
        className={cl("fieldWarning", classes.Alert)}
      />
    </div>
  )
);

const EVENT_DESCRIPTION_NAME = "eventDescription";
const EventDescription = connect(({ formik }) => (
  <div className={stage3Classes.EventDescription}>
    <label htmlFor="eventDescription" style={{ fontSize: "16px" }}>
      Tell us more about your event
    </label>
    <textarea
      id="eventDescription"
      name="eventDescription"
      data-ga={EVENT_DESCRIPTION_NAME}
      data-test-id="venueSearch-moreDescription"
      placeholder={eventDescriptionPlaceholder}
      onChange={({ target: { value } }) =>
        formik.setFieldValue(EVENT_DESCRIPTION_NAME, value)
      }
      style={{
        height: "114px",
        marginTop: ".6rem",
        resize: "none",
        width: "100%",
        borderRadius: "5px",
        color: "inherit",
        fontSize: "12pt",
      }}
    ></textarea>
  </div>
));

const EventTypeTabs = ({ isCorporate }) => (
  <div className="navigation-tabs">
    <div className={classes.FormControl}>
      <PriceSlider />
    </div>
    <CorporateOrPrivateRadio />
    <div>
      <div className={classes.FormControl}>
        <Checkbox name="virtualEvents">
          I'm interested in Virtual Events
        </Checkbox>
      </div>
      <div className={classes.FormControl}>
        <Checkbox name="isMultipleEvents">
          I organise multiple events per year
        </Checkbox>
      </div>
      <CSSTransition
        in={isCorporate}
        timeout={300}
        classNames={companyNameFieldTransitions}
        unmountOnExit
      >
        <div className={classes.FormControl}>
          <div className={stage3Classes.CompanyName}>
            <TextInput name="userCompany" label="Your company name" value="" />
          </div>
        </div>
      </CSSTransition>
      <div className={classes.FormControl}>
        <EventDescription />
      </div>
    </div>
  </div>
);

EventTypeTabs.propTypes = {
  isCorporate: PropTypes.bool.isRequired,
};

const BudgetAndCorpOrPrivateStage = connect(({ formik }) => {
  const { flavour } = useContext(ConfigContext);
  const isSelfService =
    !formik.values.isCorporate && venueFinderFlavours.includes(flavour);

  return (
    <div className={classes.Form}>
      <div className={classes.StageWrapper}>
        <EventTypeTabs isCorporate={!!formik.values.isCorporate} />
        {/* {!isSelfService &&
          <p>Your enquiry will be fast-tracked with an upgrade to our Concierge team.</p>
        } */}
      </div>
    </div>
  );
});

export default BudgetAndCorpOrPrivateStage;
